export default __webpack_public_path__ + "static/media/linkedin.070809f5.svg";